<template>
    <div class="content">
        <div class="search_wrapper">
            <div class="search_head">
                <span>查询条件</span>
                <i
                    class="searchDomw"
                    @click="isSearchContent = !isSearchContent"
                    :class="
                        isSearchContent == true
                            ? 'el-icon-arrow-up'
                            : 'el-icon-arrow-down'
                    "
                ></i>
                <!-- <el-button
                    style="float: right; padding: 3px 0; color: #000"
                    type="text"
                    @click="clearData"
                >
                    <i class="el-icon-refresh"></i>
                    刷新页面
                </el-button> -->
            </div>
            <div class="search_content" v-show="isSearchContent">
                <div class="search_inline" v-show="isSearchContent">
                    <el-form label-width="90px">
                        <el-row>
                            <el-col :span="5">
                                <el-form-item label="活动名称">
                                    <el-input
                                        v-model="activityName"
                                        placeholder="请输入活动名称"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="活动时间">
                                    <el-date-picker
                                        type="datetimerange"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        range-separator="至"
                                        style="width: 100%"
                                        v-model="recTime"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        @change="recTimeChange"
                                    >
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="活动状态">
                                    <el-select
                                        style="width: 100%"
                                        v-model="activityFlag"
                                        clearable
                                        placeholder="活动状态"
                                    >
                                        <el-option label="未开始" value="0">
                                        </el-option>
                                        <el-option label="进行中" value="1">
                                        </el-option>
                                        <el-option label="已结束" value="2">
                                        </el-option>
                                        <el-option label="已中止" value="3">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5" :offset="1">
                                <el-button
                                    type="primary"
                                    icon="el-icon-search"
                                    @click="searchData"
                                    class="searchBtns"
                                    >搜索</el-button
                                >
                                <el-button
                                    type="info"
                                    icon="el-icon-delete"
                                    @click="clearData"
                                    >清除条件</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- <div class="arrowDown">
                    <i
                        :class="
                            isSearchContent === true
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                        "
                        style="color: #000"
                        @click="isSearchContent = !isSearchContent"
                    ></i>
                </div> -->
            </div>
        </div>
        <div class="table_title">
            <div class="btn_group">
                <el-button-group>
                    <el-button
                        type="success"
                        icon="iconfont icon-xinzeng"
                        class="openBtns"
                        @click="handleTableForm('新增', 'add')"
                        >新增</el-button
                    >
                </el-button-group>
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="clearData"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                    <el-dropdown
                        trigger="click"
                        :hide-on-click="false"
                        class="dropdown1"
                    >
                        <span class="el-dropdown-link">
                            <i
                                class="el-icon-s-grid el-icon--right"
                                style="color: #fff"
                            ></i>
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu
                            slot="dropdown"
                            class="table_checkbox"
                        >
                            <el-dropdown-item>
                                <el-checkbox-group
                                    v-model="tableChekbox"
                                    @change="tableChekboxChange"
                                >
                                    <el-checkbox label="序号"></el-checkbox
                                    ><br />
                                    <el-checkbox label="活动名称"></el-checkbox
                                    ><br />
                                    <el-checkbox
                                        label="活动开始时间"
                                    ></el-checkbox
                                    ><br />
                                    <el-checkbox
                                        label="活动结束时间"
                                    ></el-checkbox
                                    ><br />
                                    <el-checkbox label="活动地点"></el-checkbox
                                    ><br />
                                    <el-checkbox label="活动内容"></el-checkbox
                                    ><br />
                                    <el-checkbox label="活动状态"></el-checkbox
                                    ><br />
                                    <el-checkbox label="审核状态"></el-checkbox
                                    ><br />
                                    <el-checkbox label="操作"></el-checkbox
                                    ><br />
                                </el-checkbox-group>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- tableb表格 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="活动名称"
                    align="center"
                    prop="activityName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '活动名称'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="活动开始时间"
                    align="center"
                    prop="beginTime"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '活动开始时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="活动结束时间"
                    align="center"
                    prop="endTime"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '活动结束时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="活动地点"
                    align="center"
                    prop="address"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '活动地点'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="活动内容"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '活动内容'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-html="scope.row.content"></span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="活动状态"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '活动状态'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.activityFlag == 0">未开始</span>
                        <span v-if="scope.row.activityFlag == 1">进行中</span>
                        <span v-if="scope.row.activityFlag == 2">已结束</span>
                        <span v-if="scope.row.activityFlag == 3">已中止</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="审核状态"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '审核状态'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.auditFlag == 0">审核未通过</span>
                        <span v-if="scope.row.auditFlag == 1">待审核</span>
                        <span v-if="scope.row.auditFlag == 2">审核通过</span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="操作"
                    width="300"
                    align="center"
                    fixed="right"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                >
                    <template slot-scope="scope">
                        <span
                            @click="handleTableForm('查看', scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >查看</span
                        >
                        <span
                            v-if="scope.row.auditFlag == 1"
                            @click="handleTableForm('审核', scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >审核</span
                        >
                        <span
                            @click="deleteItem(scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >删除</span
                        >
                        <span
                            @click="endItem(scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >终止</span
                        >
                        <span
                            @click="signItem(scope.row)"
                            style="margin-right: 12px; cursor: pointer"
                            >签到表</span
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-size="pageOne.pageSize"
                :current-page.sync="pageOne.pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageOne.total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>
        <form-open
            v-if="formVisible"
            :openData="formInfo"
            @cancleOpen="cancleOpen"
            @getList="getList"
        ></form-open>
        <sigin-info
            v-if="signVisible"
            :openData="signInfo"
            @cancleOpen="cancleOpen"
        ></sigin-info>
    </div>
</template>
<script>
import formOpen from "./components/formOpen"
import siginInfo from "./components/signInfo"
export default {
    props: ["personData"],
    components: { formOpen, siginInfo },
    data() {
        return {
            signInfo: {},
            signVisible: false,
            formInfo: {},
            formVisible: false,
            name: "",
            phone: "",
            personIdCard: "",
            recTime: "",
            isSearchContent: false,
            pageOne: { pageSize: 10, pageNo: 1, total: 0 },
            tableData: [],
            dialogVisible: false, //人员编辑
            dialogInfo: {},
            personState: false, //新增人员
            personInfo: {},
            radioId: "",
            activityName: "",
            createDate: "",
            activityFlag: "",
            tempTableChekbox: [
                "序号",
                "活动名称",
                "活动开始时间",
                "活动结束时间",
                "活动地点",
                "活动内容",
                "活动状态",
                "审核状态",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "活动名称",
                "活动开始时间",
                "活动结束时间",
                "活动地点",
                "活动内容",
                "活动状态",
                "审核状态",
                "操作",
            ],
        }
    },
    created() {
        this.getList()
    },
    watch: {
        personData(old, news) {
            // console.log(old, news, this.personData, "组织id");
            this.getList()
        },
    },
    methods: {
        // 签到表
        signItem(row) {
            console.log(row)
            this.signVisible = true
            this.signInfo = {
                id: row.auditId,
                state: true,
                socialOrgId: this.personData,
                customerId: row.customerId,
            }
        },
        // 终止
        endItem(date) {
            let params = {
                id: date.id,
            }
            this.$confirm("确认终止吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/ypt/orgWork/communityActivity/info/stop",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success("终止成功")
                            // this.tableData = [];
                            this.getList()
                        }
                    })
            })
        },
        //活动时间发生变化
        recTimeChange(val) {
            if (!val) return
            this.beginTime = val[0]
            this.endTime = val[1]
            console.log(this.beginTime, this.endTime)
        },
        // 搜索
        searchData() {
            this.getList()
        },
        cancleOpen() {
            this.formVisible = false
        },
        //删除表格信息
        deleteItem(date) {
            console.log(date)
            let params = {
                id: date.id,
            }
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/ypt/orgWork/communityActivity/info/deleteById",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success("删除成功")
                            this.getList()
                        }
                    })
            })
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        //重置
        clearData() {
            this.createDate = ""
            this.beginTime = ""
            this.endTime = ""
            this.recTime = ""
            this.activityName = ""
            this.activityFlag = ""
            this.pageOne.pageSize = 10
            this.pageOne.pageNo = 1
            this.getList()
        },
        // 获取数据
        getList() {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                socialOrgId: this.personData,
                activityName: this.activityName,
                endTime: this.endTime,
                beginTime: this.beginTime,
                createDateStr: this.createDate,
                activityFlag: this.activityFlag,
            }
            this.$http
                .request({
                    url: "/ypt/orgWork/communityActivity/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.pageOne.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },
        // 操作方法
        handleTableForm(title, row) {
            this.formInfo = {
                title: title,
                id: row != "add" ? row.id : "",
                state: true,
                socialOrgId: this.personData,
                customerId: row.customerId,
            }
            this.formVisible = true
        },
    },
}
</script>
<style lang="less" scoped>
/deep/.btn_group {
    margin-top: 0px !important;
}
/deep/.table_title {
    margin-top: 10px !important;
}

/deep/ .search_wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    background: #f1f2f6;
    box-shadow: 0 0 6px rgba(100, 100, 100, 0.16);
    overflow: hidden;
    border-radius: 4px;
    .search_head {
        background: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: rgb(0, 0, 0);
        border-color: rgb(217, 217, 217);
        padding: 6px 15px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    .search_content {
        padding: 15px 20px 0px 5px;
        border: 1px solid rgb(217, 217, 217);
        // display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .search_inline {
        width: 100%;
    }
    .arrowDown {
        width: 28px;
        height: 28px;
        background: #edf2f0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 50%;
        bottom: -14px;
        transform: translate(-50%, 0px);
        border-radius: 50%;
        z-index: 2;
        cursor: pointer;
    }
}
.searchDomw {
    cursor: pointer;
}
</style>